export default __webpack_public_path__ + "static/media/clobber2.2d1915af.png";